module.exports = __webpack_public_path__ + "static/media/b21@2x.d380aae9.png";